import React from "react";
import "./Header.css";

function Header(){
    return(
        <h1 className="header">Carriculum Vitae</h1>
    )
}

export default Header;